module.exports = __webpack_public_path__ + "media/images/front/pc/article/thum04-d6668bca316599b092ef318af869f212.png";